import React, { useEffect, useRef, useState } from "react";
import useAuth from "../../hooks/useAuth";
import useFetch from "../../hooks/useFetch";
import { CAMP_CONTROLL } from "../../utils/ApiUrls";
import { ReactComponent as Start } from "../../assets/images/svg/Start.svg";
import { ReactComponent as Stop } from "../../assets/images/svg/stop.svg";
import { ReactComponent as Edit } from "../../assets/images/svg/Edit.svg";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import { Link, useNavigate } from "react-router-dom";
import { TopDisappearingMessage } from "../../utils/Common";
import Pagination from "../../components/Table/pagination";
import Tooltip from "../../components/Elements/Tooltip";

import axios from "axios";
import Swal from "sweetalert2";
import useSocket from "../../hooks/useWebsocket";

const COLUMN_META = {
  "Sl-No": { width: "w-[6%]", align: "text-start" },
  "": { width: "w-[3%]", align: "text-center" },
  "Status": { width: "w-[11%]", align: "text-center" },
  "Campaign Mode": { width: "w-[9%]", align: "text-start" },
  "Total Customers": { width: "w-[10%]", align: "text-center" },
  "Called": { width: "w-[8%]", align: "text-center" },
  "To be Called": { width: "w-[9%]", align: "text-center" },
  "DNC": { width: "w-[6%]", align: "text-center" },
  "No of Assigned Agents": { width: "w-[11%]", align: "text-center" },
  "Start/Stop": { width: "w-[6%]", align: "text-center" },
  "Action": { width: "w-[6%]", align: "text-center" },
};

const CampaignList = (props) => {
  const { auth } = useAuth();
  const tooltipText = ["Item 1", "Item 2", "Item 3"];

  const navigate = useNavigate()

  const Initial_pagination = {
    next: "",
    previous: "",
    count: "",
    total_pages: "",
    current_page: 1,
    page_size: 5,
  };

  const[isReady,val,send,disconnect] = useSocket();
  // const isReady = false;

  const [loadingId,setLoadingId] = useState(null);

  const [campaigns, setcampaigns] = useState([]);
  const [pagination, setPagination] = useState(Initial_pagination);
  const [searchtext, setsearchtext] = useState("");

  var sortFilter = useRef("");

  const PaginationControl = (type, number) => {
    if (type == "page") {
      if (number <= pagination.total_pages) {
        fetchCampaignData(number);
      } else {
        fetchCampaignData(1);
      }
    } else if (type == "last") {
      fetchCampaignData(pagination.total_pages);
    } else if (type == "prev") {
      if (pagination.current_page > 1) {
        fetchCampaignData(pagination.current_page - 1);
      }
    } else if (type == "next") {
      if (pagination.current_page < pagination.total_pages) {
        fetchCampaignData(pagination.current_page + 1);
      }
    } else {
      fetchCampaignData(1);
    }
  };

  const SearchSubmit = () => {
    fetchCampaignData(1);
  };

  const fetchCampaignData = async (pagenumber) => {
    let camp_post_data;

    console.log("Auth    :  ",auth)

    if (props.user_type === "agent") {
      camp_post_data = {
        user_id: auth?.user_details?.user,
        user_type: props.user_type,
        page: pagenumber,
        search: searchtext,
        sortby:sortFilter.current.value
      };
    } else {
      camp_post_data = {
        user_id: auth?.user_details?.user,
        user_type: props.user_type,
        page: pagenumber,
        search: searchtext,
        sortby:sortFilter.current.value
      };
    }

    let config = {
      headers: { "Content-Type": "application/json" },
    };

    await axios
      .get(
        process.env.REACT_APP_API_URL + "/contactcentre/campaign-list/",
        {
          params: camp_post_data,
        },
        config
      )
      .then((res) => {
        console.log(JSON.stringify(res))
        if (props.camp_search) {
          setcampaigns(res.data.results);

          setPagination((prevState) => {
            return {
              ...prevState,
              total_pages: res.data?.total_pages || 0,
              previous: res.data?.previous || null,
              next: res.data?.next || null,
              current_page: res.data?.current_page || 0,
              count: res.data?.count || 0,
              page_size: res.data?.page_size || 5,
            };
          });
        } else {
          setcampaigns(res?.data?.results?.slice(0, 5) || []);
        }
      })
      .catch((err) => console.log(err));
  };

  const invalidfetch=async(camp_id)=>{
    let camp_post_data;
    let config = {
      headers: { "Content-Type": "application/json" },
      Authorization: `Bearer ${auth?.accessToken}`,
    };
    await axios
      .get(
        process.env.REACT_APP_API_URL + `/contactcentre/fetch_invalid/${camp_id}`,
        config
      )
      .then((res) => {
        console.log(JSON.stringify(res?.data))

        if(res?.data)
        {

          const invalid_data=res.data;

          const formatNumber =(number)=>{
            return Number(number).toLocaleString("en-US");
          }

          const count = parseInt(invalid_data.failed_record_count);
          var text_here="";
          if(count==1){
            text_here = `Campaign has ${invalid_data.failed_record_count} invalid record`
          }
          else if(count>=1){
            text_here = `Campaign have ${invalid_data.failed_record_count} invalid records`
          }else{
            text_here = `Campaign have no invalid records`
          }

          Swal.fire({
            title: "Campaign Has Invalid Data",
            html:`
            <table class="mx-auto mt-2 border-collapse" style="width:90%">
              <tbody>
                <tr class="border-b">
                  <td class="py-2 text-left font-semibold text-black">
                    Total records found
                  </td>
                  <td class="py-2 text-right text-black">
                    ${formatNumber(invalid_data.total_record_count)}
                  </td>
                </tr>

                <tr class="border-b">
                  <td class="py-2 text-left font-semibold text-black">
                    Valid records
                  </td>
                  <td class="py-2 text-right text-black">
                    ${formatNumber(invalid_data.valid_record_count)}
                  </td>
                </tr>

                <tr>
                  <td class="py-2 text-left font-semibold text-black">
                    Invalid records
                  </td>
                  <td class="py-2 text-right font-semibold text-red-600">
                    ${formatNumber(invalid_data.failed_record_count)}
                  </td>
                </tr>
              </tbody>
            </table>
            </br>
            <p><b style="color:black">Status :  ⚠️ <span style="color:black">Uploaded with Errors</span></b></p>
            `,
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "EDIT THE CAMPAIGN",
          }).then((result)=>{
            if(result.isConfirmed){
              navigate(`/admin/campaign/create/${camp_id}`)
            }
          });


        }

          

      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    fetchCampaignData(1);
    console.log("PROPS                             :", props);
  }, []);

  const fetchData = useFetch();

  const CampaignControl = async (camp_id, status, index) => {

    if(!isReady){
      Swal.fire({
        title:"Connection in progress",
        text:"Still connecting to the server. Please wait a moment.",
        icon:"warning",
        confirmButtonColor:"#3085d6"
      })
    }

    setLoadingId(Number(camp_id));

    let post_data = {
      campaign_id: camp_id,
      status: status,
      userId: auth?.user_details?.user,
    };

    console.log("=======camp_id==,status===", post_data);
    try{

      const res_data = await fetchData("post", post_data, CAMP_CONTROLL);

      if (res_data?.status === "success") {
        
        if (res_data) {
          if (status === "start") {
          
            TopDisappearingMessage(
              "top-start",
              2000,
              "success",
              "Campaign started for all active agents",
              false
            );
          }
          if (status === "stop") {
  
            TopDisappearingMessage(
              "top-start",
              2000,
              "warning",
              "Campaign stoped for all active agents",
              false
            );
          }
          var data = [...campaigns];
          data[index].campaign_status = status;
        }
      
      }
      
    }catch(error){
      console.error("Network or other error:", error);
      TopDisappearingMessage(
        "top-start",
        3000,
        "error",
        "Something went wrong",
        false
      );
    }finally{
      setLoadingId(null)
    }
    
  };

  const CampaignDelete = async (camp_id, status, index) => {
    console.log("<<<<<STATUS>>>>>", status);
    if (status === "start") {
      Swal.fire({
        title: "Do not delete !",
        text: "This campaign is currently running...",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
    } else {
      Swal.fire({
        title: "Are you sure to Delete?",
        text: "All data associated with this campaign will be deleted",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setcampaigns((current) =>
            current.filter((fruit) => fruit.id !== camp_id)
          );

          let post_data = {
            user_id: auth?.user_details?.user,
            camp_id: camp_id,
          };

          let config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${auth?.accessToken}`,
            },
          };

          await axios
            .post(
              process.env.REACT_APP_API_URL + "/contactcentre/delete_campaign/",
              post_data,
              config
            )
            .then((res) => {
              console.log("=camp list loaded=", res.data);
            })
            .catch((err) => console.log(err));
        }
      });
    }
  };

  

  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between ">
          {props.camp_search && (
            <div className="flex flex-wrap items-start gap-0 ">
                  <div className=" max-[880px]:block">
                  
                      <div className="mt-1 mr-9">
                        <label htmlFor="table-search" className="sr-only">
                          Search
                        </label>
                        <div className="flex items-start">
                          <input
                            type="text"
                            id="table-search"
                            onChange={(e) => {
                              setsearchtext(e.target.value);
                            }}
                            className="max-[1250px]:w-[8.5rem] max-[1250px]:px-[0.5rem] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 h-10 pl-10 p-2.5  "
                            placeholder="Search for items"
                          />

                          <div
                            // onClick={SearchSubmit}
                            className="max-[1250px]:ml-[-35px] rounded cursor-pointer group  flex items-center justify-center h-10 w-10 ml-[-53px]"
                          >
                            <svg
                              className=" w-5 h-5 text-gray-500  group-hover:scale-[1.3] group-hover:text-gray-700"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>


                </div>
                
                  <div className="">

                        <select
                            className="max-[880px]:ml-[-1.5rem] max-[758px]:ml-[0rem] max-[1250px]:ml-[-1rem] max-[1250px]:w-[8.5rem] max-[1250px]:px-[0.1rem]  w-80  bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-10 p-2.5  mt-1 mr-6 "
                            ref={sortFilter}
                        > 
                            <option value="">Select Sort Option</option>
                            <option value={"by_name"}>By Name</option>
                            <option value={"by_created"} selected >By Creation Time</option>
                        </select>
                    
                  </div>




                  <div className="mr-2">
                      <button type="button"
                          className="max-[880px]:ml-[-1.5rem] bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-1"
                          onClick={()=>{fetchCampaignData(1)}}
                      >
                          Search
                      </button>
                  </div>

            </div>
          )}

          {props.type === "campaignlist_admin" && (
            <Link to="/admin/campaign/create/0">
              <button
                type="button"
                className="mt-[0.4rem] inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-lg transition duration-150 ease-in-out"
              >
                + ADD CAMPAIGN
              </button>
            </Link>
          )}
        </div>

        <div className="py-2 inline-block min-w-full ">
          <div className="overflow-x-auto">
            <table className="w-full table-fixed">
              <thead>
                <tr className="text-[#9AA7B5] text-[17px] font-karla font-[500]">
                  {props.theadData.map((item, idx) => {
                    const meta = COLUMN_META[item] || {};
                    return (
                      <th
                        key={`${item}-${idx}`}
                        title={item}
                        className={`${meta.width || ""} font-[500] px-3 ${meta.align || "text-start"}`}
                      >
                        {item}
                      </th>
                    );
                  })}

                  {props.type === "campaignlist_admin" && (
                    <>
                      <th
                        key="start-stop"
                        title="Start/Stop"
                        className={`${COLUMN_META["Start/Stop"].width} font-[500] px-3 ${COLUMN_META["Start/Stop"].align}`}
                      >
                        {" "}
                        Start/Stop
                      </th>

                      <th
                        key="action"
                        title="action"
                        className={`${COLUMN_META["Action"].width} font-[500] px-3 ${COLUMN_META["Action"].align}`}
                      >
                        {" "}
                        Action
                      </th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {campaigns &&
                  campaigns.map &&
                  campaigns.map((campaign, index) => (
                    <tr
                      className="border-b text-[16px] font-karla text-gray-900  whitespace-nowrap"
                      key={0 + index}
                    >
                      <td className="py-4 px-3">
                        {index +
                          1 +
                          (pagination?.current_page - 1) *
                            pagination?.page_size}
                      </td>
                      <td className="px-3 py-4 ">
                        <div className="flex justify-between items-center">
                          <span className="truncate min-w-0" title={campaign.name}>
                            {campaign.name}
                          </span>

                          {/* {props.type === "campaignlist_admin" && campaign?.is_invalid_present && campaign?.invalid_details?.failed_record_count !== "0"  && (
                          <span>
                            <div className="relative group inline-block">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#FFA500"
                                className="
                                    w-6 h-6 p-0.5 
                                    hover:fill-orange-400 hover:stroke-white hover:p-0 p-0.5 active:fill-none active:stroke-orange-500 active:p-0 p-0.5
                                    transition-colors duration-100 mt-1.5  
                                "
                                onClick={()=>handleInfo(campaign.id,campaign?.invalid_details?.failed_record_count || "0" )}
                                > 
                              <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
                              <path 
                                d="M12 8.5h.01 M12 11v4" 
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                              <span className="absolute left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap 
                                              bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 
                                              group-hover:opacity-100 transition pointer-events-none">
                                                {campaign?.invalid_details? 
                                                    "Invalid Data in campaign" 
                                                  :
                                                    "Nothing to show"
                                                }
                              </span>
                            </div>
                          </span>
                          )} */}
                        </div>
                      </td>
                      
                      <td className="px-1 py-4 text-center">
                        {props.type === "campaignlist_admin" && campaign?.is_invalid_present && (
                          <span>
                            <div className="relative group inline-block">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#FFA500"
                                className="
                                    w-6 h-6 p-0.5 
                                    hover:fill-orange-400 hover:stroke-white hover:p-0 p-0.5 active:fill-none active:stroke-orange-500 active:p-0 p-0.5
                                    transition-colors duration-100 mt-1.5  
                                "
                                onClick={()=>invalidfetch(campaign?.id)}
                                > 
                              <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
                              <path 
                                d="M12 8.5h.01 M12 11v4" 
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                              <span className="absolute left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap 
                                              bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 
                                              group-hover:opacity-100 transition pointer-events-none">
                                                {campaign?.is_invalid_present? 
                                                    "Invalid Data in campaign" 
                                                  :
                                                    "Nothing to show"
                                                }
                              </span>
                            </div>
                          </span>
                          )}
                      </td>

                      {campaign.campaign_status === "start" && (
                        <td className="px-3 py-4 text-center">
                          <span className="inline-flex items-center gap-1 rounded-full bg-yellow-50 px-2 py-1 text-xs font-semibold  text-[#fbbf24]">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#fbbf24]"></span>
                            Ongoing
                          </span>
                        </td>
                      )}

                      {campaign.campaign_status === "stop" && (
                        <td className="px-3 py-4 text-center">
                          <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-1 text-xs font-semibold text-red-600">
                            <span className="h-1.5 w-1.5 rounded-full bg-red-600"></span>
                            Not Started
                          </span>
                        </td>
                      )}

                      {campaign.campaign_status === "completed" && (
                        <td className="px-3 py-4 text-center text-[#26ae0b]">
                          <span className="inline-flex items-center gap-1 rounded-full bg-green-50 px-2 py-1 text-xs font-semibold text-green-600">
                            <span className="h-1.5 w-1.5 rounded-full bg-green-600"></span>
                            Completed
                          </span>
                        </td>
                      )}

                      <td className="px-3 py-4 ">
                        {campaign.campaign_mode || "-"}{" "}
                      </td>
                      <td className="px-3 py-4  text-center">
                        {campaign.total_customers}
                      </td>

                      <td className="px-3 py-4 text-center">
                        {campaign.called_customers}
                        {/* <div className="flex items-center justify-between">
                        <span className="text-slate-400 text-sm text-slate-500">Progress 3</span>
                        <span className="px-2 py-1 bg-teal-50 rounded-lg text-xs text-teal-400 font-medium min-w-[46px] text-center">50%</span>
                    </div> */}
                      </td>
                      <td className="px-3 py-4 text-center">
                        {campaign.tobe_called}
                      </td>
                      <td className="px-3 py-4 text-center">
                        {campaign.dnc}
                      </td>
                      <td className="px-3 py-4 text-center">
                        {campaign.agent_fields || 0}
                      </td>                      

                      {props.type === "campaignlist_admin" && (
                        <>
                          <td className="px-3 py-4 text-center">
                            {loadingId===campaign.id? 
                              <>
                                <div className="flex justify-center rounded-md p-2 cursor-pointer  text-gray-300 text-sm items-center gap-x-4 pe-3 ">
                                 <svg
                                    className="w-5 h-5 animate-spin text-blue-600"
                                    viewBox="0 0 50 50"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      className="opacity-25"
                                      cx="25"
                                      cy="25"
                                      r="17"
                                      stroke="currentColor"
                                      strokeWidth="10"
                                      fill="none"
                                    />
                                    <circle
                                      className="opacity-75"
                                      cx="25"
                                      cy="25"
                                      r="17"
                                      stroke="currentColor"
                                      strokeWidth="10"
                                      strokeLinecap="round"
                                      fill="none"
                                      strokeDasharray="31.4 188.4"
                                    />
                                  </svg>

                                </div>
                              </>
                              :
                              <>
                              {(campaign.campaign_status === "stop" || campaign.campaign_status === "completed") && (
                              <div
                                onClick={() => {
                                  CampaignControl(campaign.id, "start", index);
                                }}
                                className="flex justify-center rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4"
                              >
                                <Start
                                  className={`width="26" height="26" fill="blue"`}
                                  viewBox="0 0 26 26"
                                  fill="green"
                                  cx="8.5"
                                  cy="8.5"
                                  r="6"
                                  fillRule="evenodd"
                                  fillOpacity=".8"
                                />
                              </div>
                            )}

                            {campaign.campaign_status === "start" && (
                              <div
                                onClick={() => {
                                  CampaignControl(campaign.id, "stop", index);
                                }}
                                className="flex justify-center rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4"
                              >
                                <Stop
                                  className={`width="26" height="26" fill="blue"`}
                                  viewBox="0 0 26 26"
                                  fill="red"
                                  cx="8.5"
                                  cy="8.5"
                                  r="6"
                                  fillRule="evenodd"
                                  fillOpacity=".8"
                                />
                              </div>
                            )}
                              </>
                            }
                            
                            
                          </td>
                          <td className="p-3 flex">
                            <div className="flex justify-between">
                              <Link
                                to={`/admin/campaign/create/${campaign.id}`}
                              >
                                <div className="flex  rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4">
                                  <Edit
                                    className={`width="26" height="26" fill="blue"`}
                                    viewBox="0 0 26 26"
                                    fill="green"
                                    cx="8.5"
                                    cy="8.5"
                                    r="6"
                                    fillRule="evenodd"
                                    fillOpacity=".8"
                                  />
                                </div>
                              </Link>
                              <div
                                onClick={() => {
                                  CampaignDelete(
                                    campaign.id,
                                    campaign.campaign_status,
                                    "stop",
                                    index
                                  );
                                }}
                                className="flex  rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4"
                              >
                                <Delete
                                  className={`width="26" height="26" fill="blue"`}
                                  viewBox="0 0 26 26"
                                  fill="red"
                                  cx="8.5"
                                  cy="8.5"
                                  r="6"
                                  fillRule="evenodd"
                                  fillOpacity=".8"
                                />
                              </div>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {props.camp_search && (
          <div className="p-8">
            <Pagination
              pagination_data={pagination}
              PaginationControl={PaginationControl}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default React.memo(CampaignList);
